/* eslint-disable no-plusplus */
import React, { useCallback, useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import {
  View,
  Image,
  Text,
  Storage,
  TouchableOpacity,
  ScrollView,
} from '../../../app-components';
import theme from './navigationBarStyle';
import {
  appraiseLogo,
  manageAdminAppraiseAllLogo,
  manageDealerKycLogo,
  rulesLogo,
  bellLogo,
  gearLogo,
  dealerEmployeeIcon,
  uciReportIcon,
  monitorIcon,
  dealerSettingsLogo,
  appraisalIcon,
} from '../../../images';
import { ROUTES } from '../../../Lib/constants';
import { getImageUrl, refreshUserToken } from '../../../AppServices';
import { isMobile } from '../../../app-components/UtilityFunctions';
import { getUserRole } from '../../../Lib/helpers';
import './sidebar.css'
// import colpase from './colpase.svg'

const renderUsingAccessKey = (ak) => {
  const userRole = getUserRole();

  for (let i = 0; i < ak.length; i++) {
    if (userRole === ak[i]) {
      return true;
    }
  }
  return false;
};

const renderUsingSection = (tab) => {
  if (tab.section === 'Profile') {
    return true;
  }
  return false;
};

const tabsDef = () => {
  const userRole = getUserRole();
  console.log('userRole', userRole)
  let routeForRule = '';
  let routeForDashboard = '';
  let routeForNotification = '';

  if (userRole === 'superadmin' || userRole === 'admin') {
    routeForRule = ROUTES.avRulesListSA.name;
    routeForDashboard = ROUTES.WelcomeSA.name;
    
  } else if (userRole === 'dealer' || userRole === 'manager' || userRole === 'employee' || userRole === 'superdealer' ) {
    routeForRule = ROUTES.avRulesListDealer.name;
    routeForDashboard = ROUTES.WelcomeDealer.name;
    routeForNotification = ROUTES.NotificationUnsub.name;

  }

  const arr = [
    {
      label: 'Admins',
      icon: manageAdminAppraiseAllLogo,
      route: ROUTES.adminData.name,
      access_key: ['superadmin'],
      section: 'Module',
      message: 'Manage Admins',
    },
    {
      label: 'Dealers',
      icon: manageDealerKycLogo,
      route: ROUTES.dealerData.name,
      access_key: ['superadmin', 'admin'],
      section: 'Module',
      message: 'Manage Dealers',
    },
    {
      label: 'Sub Dealers',
      icon: manageDealerKycLogo,
      route: ROUTES.superDealerData.name,
      access_key: ['superdealer'],
      section: 'Module',
      message: 'Manage Dealers',
    },
    {
      label: 'All Dealers',
      icon: manageDealerKycLogo,
      route: ROUTES.allDealerData.name,
      access_key: ['manager', 'employee'],
      section: 'Module',
      message: 'Manage Dealers',
    },
    {
      label: 'Unsubscribe',
      icon: bellLogo,
      route: ROUTES.NotificationUnsub.name,
      access_key: ['superadmin', 'admin'],
      section: 'Module',
      message: 'Manage Notification',
    },
    {
      label: 'Unsubscribe',
      icon: bellLogo,
      route: ROUTES.NotificationUnsubDealer.name,
      access_key: ['dealer, manager', 'superdealer'],
      section: 'Module',
      message: 'Manage Notification',
    },
    {
      label: 'Rules',
      icon: rulesLogo,
      route: routeForRule,
      access_key: ['dealer', 'superadmin', 'admin', 'manager', 'superdealer', 'employee'],
      section: 'Module',
      message: 'Manage Rules',
    },
    {
      label: 'Employees',
      icon: dealerEmployeeIcon,
      route: ROUTES.employeeData.name,
      access_key: ['dealer', 'manager', 'superdealer'],
      section: 'Module',
      message: 'Manage Employees',
    },

    {
      label: 'Repair Orders',
      icon: appraisalIcon,
      route: ROUTES.fiSaleClosedList.name,
      access_key: ['dealer', 'manager', 'superdealer'],
      section: 'Module',
      message: 'All Repair Orders Currently Open',
    },
    // {
    //   label: 'Appraisals Generated',
    //   icon: gearLogo,
    //   route: ROUTES.appraisalHistoryListAll.name,
    //   access_key: ['dealer', 'admin', 'superadmin'],
    //   section: 'Module',
    //   message: 'Check All The Appraisals Generated',
    // },
    // {
    //   label: 'Captured Appraisals',
    //   icon: uciReportIcon,
    //   route: ROUTES.uciReportList.name,
    //   access_key: ['dealer', 'admin', 'superadmin'],
    //   section: 'Module',
    //   message: 'Check All Captured Appraisals',
    // },
    // {
    //   label: 'Manage Master Data',
    //   icon: masterDataIcon,
    //   route: ROUTES.masterData.name,
    //   modal: true,
    //   access_key: ['superadmin'],
    //   section: 'Module',
    //   message: 'Upload Master Data Here',
    // },

    {
      label: 'Appraisals Generated',
      icon: gearLogo,
      route: ROUTES.ARListAvgen.name,
      access_key: ['superadmin', 'admin', 'dealer', 'employee', 'manager', 'superdealer'],
      section: 'Module',
      message: 'Appraisal Result Generated',
    },

    {
      label: 'Appraisals Captured',
      icon: uciReportIcon,
      route: ROUTES.ARListUCI.name,
      access_key: ['superadmin', 'admin', 'dealer', 'employee', 'manager', 'superdealer'],
      section: 'Module',
      message: 'Appraisal Result Captured',
    },
  ];

  arr.push({
    label: 'Dashboard',
    icon: monitorIcon,
    route: routeForDashboard,
    section: 'Profile',
    access_key: [],
    message: 'Check Your Activities Here',
  });

  if (userRole === 'dealer' || userRole === 'superdealer' || userRole === 'manager') {
    arr.push({
      label: 'Settings',
      icon: dealerSettingsLogo,
      route: ROUTES.dealerSettings.name,
      section: 'Profile',
      access_key: [],
      message: 'Account Settings',
    });
  }

  return arr;
};

const Sidebar = (props) => {
  const { user, navigation } = props;

  const [selectedTab, setSelectedTab] = useState('');
  const [sidebarTextVisible] = useState(!isMobile);
  const [logo] = useState();

  // console.log("sidebarTextVisible", sidebarTextVisible)

  useEffect(() => {
    const interval = setInterval(() => {
      Storage.getItem('tokenExpiryTime').then((tokenExpiryTime) => {
        const currentDate = new Date();
        const tokenExpiryDate = new Date(parseInt(tokenExpiryTime, 10));
        const diffTimeInMinutes = (tokenExpiryDate - currentDate) / (1000 * 60);

        if (diffTimeInMinutes < 5 && diffTimeInMinutes > 0) {
          refreshUserToken();
        }
      });
    }, 1000 * 30);

    return () => clearInterval(interval);
  }, []);

  const onTabChange = useCallback(
    (parentRoute) => {
      if (parentRoute) {
        navigation.replace(parentRoute);
        setSelectedTab(parentRoute);
      }
    },
    [navigation],
  );

  useEffect(() => {
    if (navigation?.state?.routeName) {
      setSelectedTab(navigation?.state?.routeName);
    }
  }, [navigation.state.routeName]);

  if (!user || user.enforceChangePassword) {
    return <View />;
  }

  return (
    <SidebarForOthers
      navigation={navigation}
      setSelectedTab={setSelectedTab}
      logo={logo}
      sidebarTextVisible={sidebarTextVisible}
      onTabChange={onTabChange}
      selectedTab={selectedTab}
    />
  );
};

const SidebarForOthers = (props) => {
  const {
    logo,
    sidebarTextVisible,
    onTabChange,
    selectedTab,
    setSelectedTab,
    navigation,
  } = props;
  const tabArrGot = tabsDef();

  let profileSectionTabsCount = 0;
  for (let i = 0; i < tabArrGot.length; i++) {
    if (tabArrGot[i].section === 'Profile') {
      profileSectionTabsCount++;
    }
  }

  return (
    <View style={theme.wrapperForBorderRadius} className="noNeedToPrint">
      <div className="sidebar">
      <View style={theme.logoImage}>
        <TouchableOpacity>
          <View
            style={{
              width: '100%',
              paddingLeft: '5px',
              marginTop: '10px',
              // border: '1px solid red',
              // display: 'flex',
              // flexDirection: 'row',
              // justifyContent: 'space-around',
              // alignItems: 'center',
            }}
          >
            <Image
              source={logo ? getImageUrl(logo) : appraiseLogo}
              style={{
                width: sidebarTextVisible ? 120 : 60, // 155 : 60,
                height: sidebarTextVisible ? 60 : 40, // 80 : 40,
                marginBottom: !sidebarTextVisible && 15,
              }}
            />
            {/* <Image
              source={rulesLogo}
              style={{
                width: sidebarTextVisible ? 20 : 40, // 155 : 60,
                height: sidebarTextVisible ? 20 : 20, // 80 : 40,
                marginBottom: !sidebarTextVisible && 15,
                baackgrounColor: 'white',
                color:'white'

              }}
            /> */}
          </View>
          <View
            style={{
              width: '100%',
              padding: 8,
              fontSize: '14px',
              fontStyle: 'italic',
              color: '#E9E9E9',
            }}
          >
            {profileSectionTabsCount > 0 ? 'Profile' : null}
          </View>

          <ScrollView style={theme.tabsWrapper}>
            {tabArrGot.map(
              (tab, index) => renderUsingSection(tab) && (
              <RenderTab
                {...tab}
                key={index}
                selectedSubMenuOption={props?.navigation?.state?.routeName}
                onTabChange={onTabChange}
                selectedTab={selectedTab}
                sidebarTextVisible={sidebarTextVisible}
                navigation={navigation}
                setSelectedTab={setSelectedTab}
              />
              ),
            )}
          </ScrollView>
        </TouchableOpacity>
        <View
          style={{
            borderBottom: '5px solid white',
            width: '100%',
            color: 'transparent',
            marginBottom: '20px',
          }}
        >
          border text is transparent
        </View>
      </View>
      <View
        style={{
          width: '100%',
          padding: 8,
          fontSize: '14px',
          fontStyle: 'italic',
          color: '#E9E9E9',
        }}
      >
        Modules
      </View>
      <ScrollView style={theme.tabsWrapper} >
        {tabArrGot.map(
          (tab, index) => renderUsingAccessKey(tab.access_key) && (
          <RenderTab
            {...tab}
            key={index}
            selectedSubMenuOption={props?.navigation?.state?.routeName}
            onTabChange={onTabChange}
            selectedTab={selectedTab}
            sidebarTextVisible={sidebarTextVisible}
            navigation={navigation}
            setSelectedTab={setSelectedTab}
          />
          ),
        )}
      </ScrollView>
      </div>
    </View>
  );
};

const RenderTab = (props) => {
  const {
    label,
    icon,
    route,
    onTabChange,
    selectedTab,
    sidebarTextVisible,
    message,
    navigation,
    setSelectedTab,
  } = props;

  setSelectedTab(navigation.state.routeName);

  const [hover, setHover] = useState(false);

  const mouseEnter = () => {
    setHover(true);
  };

  const mouseLeft = () => {
    setHover(false);
  };

  const handleOptionSelect = useCallback(() => {
    onTabChange(route);
  }, [onTabChange, route]);
  let a = false
  return (
    <>
    { sidebarTextVisible && <ReactTooltip place="right" type="light" effect="float" id={route} />}

      <ScrollView
        style={
          selectedTab === route || hover
            ? theme.selectedTabWrapper
            : theme.tabWrapper
        }
      >
        <div data-tip={message || 'no-tooltip-added'} data-for={route}>
          <View
            onPress={handleOptionSelect}
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeft}
            style={theme.tabTouchableContainerStyle}
          >
            <Image source={icon} style={theme.tabIconProperties} />
            {sidebarTextVisible && (
              <Text
                style={
                  selectedTab === route || hover
                    ? theme.selectedTabText
                    : theme.tabText
                }
              >
                {label}
              </Text>
            )}
          </View>
        </div>
      </ScrollView>
    </>
  );
};

export default Sidebar;
